/**
 * Product image gallery — thumbnail-driven fade switcher.
 *
 * Runs after window.load so FlexSlider has already generated
 * .flex-control-thumbs before we read them. The CSS overrides
 * FlexSlider's transform/height so only our opacity logic is visible.
 */
export function initProductGallery() {
	const setup = () => {
		document
			.querySelectorAll( '.pdp-gallery-col .woocommerce-product-gallery' )
			.forEach( ( gallery ) => {
				const slides = [
					...gallery.querySelectorAll(
						'.woocommerce-product-gallery__image'
					),
				];
				const thumbItems = [
					...gallery.querySelectorAll( '.flex-control-thumbs li' ),
				];

				if ( ! slides.length ) {
					return;
				}

				const goTo = ( i ) => {
					slides.forEach( ( s ) =>
						s.classList.remove( 'pdp-slide-active' )
					);
					thumbItems.forEach( ( t ) =>
						t
							.querySelector( 'img' )
							?.classList.remove( 'flex-active' )
					);
					slides[ i ]?.classList.add( 'pdp-slide-active' );
					thumbItems[ i ]
						?.querySelector( 'img' )
						?.classList.add( 'flex-active' );
				};

				// Show the first slide on init
				goTo( 0 );

				thumbItems.forEach( ( thumb, i ) => {
					thumb.addEventListener( 'click', () => goTo( i ) );
				} );
			} );
	};

	if ( document.readyState === 'complete' ) {
		setup();
	} else {
		window.addEventListener( 'load', setup );
	}
}
